export enum PublicSafetyCoordinatorCodeEnum {
    PSCA = 'PSCA',
}
